import { useState } from "react";
import {
  gridFilteredSortedRowIdsSelector,
  useGridApiRef,
  type GridRowId,
  type GridRowSelectionModel,
} from "@mui/x-data-grid";

/** Só quem está Pronto ou Em espera pode ser retido; quem já está Retido ou Criticado fica de fora. */
export function selecionavel(status: string): boolean {
  return status === "READY" || status === "DELAYED";
}

/**
 * O alvo do lote: seleção (`exclude` vale como "todas as visíveis menos estas")
 * ∩ linhas visíveis (filtro e ordenação atuais) ∩ elegíveis.
 */
export function idsAlvo(
  modelo: GridRowSelectionModel,
  visiveis: GridRowId[],
  rows: { id: GridRowId; status: string }[],
): GridRowId[] {
  const status = new Map(rows.map((r) => [r.id, r.status]));
  return visiveis.filter(
    (id) =>
      (modelo.type === "exclude" ? !modelo.ids.has(id) : modelo.ids.has(id)) &&
      selecionavel(status.get(id) ?? ""),
  );
}

/** A mesma marcação de Retido do ícone da linha, aplicada a cada id do lote. */
export function marcarRetidas<T extends { id: GridRowId }>(
  rows: T[],
  ids: GridRowId[],
  retentionReason: string,
  retentionNotes: string,
): T[] {
  const alvo = new Set(ids);
  return rows.map((r) => (alvo.has(r.id) ? { ...r, status: "SKIPED", retentionReason, retentionNotes } : r));
}

export function useSelecaoEmLote() {
  const apiRef = useGridApiRef();
  const [modelo, setModelo] = useState<GridRowSelectionModel>({ type: "include", ids: new Set() });
  const limpar = () => setModelo({ type: "include", ids: new Set() });
  // Antes de a grade montar não há filtro a consultar: vale a lista inteira.
  const alvo = (rows: { id: GridRowId; status: string }[]) =>
    idsAlvo(
      modelo,
      apiRef.current ? gridFilteredSortedRowIdsSelector(apiRef) : rows.map((r) => r.id),
      rows,
    );
  return { apiRef, modelo, setModelo, limpar, alvo };
}
